// extracted by mini-css-extract-plugin
module.exports = {"Files":"sert_Files__PDo9V","File":"sert_File__UYmop","Name":"sert_Name__zyQS5","SertLanding":"sert_SertLanding__W0xNd"};